import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const adjustPreviewModalSchema = yupResolver(
  yup.object({
    accounts: yup.array().of(
      yup.object({
        account: yup.string().required('Conta é obrigatória'),
        adjustmentValue: yup.string().required('Valor do ajuste é obrigatório'),
        observations: yup.string().required('Observações é obrigatória')
      })
    )
  })
)
